import axios from '@/lib/axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import { PaymentTaskExpenseAccountItem, SalesOrderWeeklySummaryComparison } from '@/hooks/api/models';

/**
 * 2400. 週次分析比較
 * [GET] /workspaces/:identifier/weekly_summaries/comparison
 */
type Props = {
  identifier: string;
  before_weekly_summary_id?: number;
  after_weekly_summary_id?: number;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  business_partner_ids?: number[];
  agency_ids?: number[];
  enabled?: boolean;
};

const weeklySummaryComparison = (props: Props): Promise<SalesOrderWeeklySummaryComparison> => {
  return axios.get(`/api/workspaces/${props.identifier}/weekly_summaries/comparison`, { params: props });
};

export const useWeeklySummaryComparison = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'weeklySummaries', 'comparison', { ...props }],
    queryFn: () => weeklySummaryComparison(props),
    enabled: props.enabled,
  });
};

export const useWeeklySummaryComparison2 = (props: Props) => {
  return useMutation({
    mutationFn: weeklySummaryComparison,
  });
};
